import React, { useState } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import style from './modalsStyles.module.css';

Modal.setAppElement('#root');

function cannotPostulateModal({ isOpen, school, onRequestClose }) {
  const [infoAboutPostulation, setInfoAboutPostulation] = useState(false);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName={style.reactModal__overlay}
      className={style.cannotPostulateModal__container}
    >
      <p className={style.cannotPostulateModal__header}>
        Lamentablemente esta Institución
        no permite
        postulaciones en este momento a través de VACANTED™
      </p>
      <div className={style.cannotPostulateModal__checkContainer}>
        <div className={style.checkbox__holder}>
          <input
            type="checkbox"
            className={style.cannotPostulateModal__checkbox}
            checked={infoAboutPostulation}
            onChange={(e) => setInfoAboutPostulation(e.target.checked)}
          />
        </div>
        <div className={style.span__holder}>
          <span className={style.input_span}>
            Deseo recibir un aviso cuando las postulaciones de esta
            institución estén habilitadas en VACANTED™
          </span>
        </div>
      </div>
      <button
        type="button"
        className={style.cannotPostulateModal__btn}
        onClick={() => onRequestClose(infoAboutPostulation, school)}
      >
        ACEPTAR
      </button>
    </Modal>
  );
}

cannotPostulateModal.defaultProps = {
  school: {},
};

cannotPostulateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  school: PropTypes.shape({}),
};

export default cannotPostulateModal;
